import { baseUrl } from "../config/config";
import axios from 'axios';

// get all Hira
export const getAllHira = async () => {
  try {
    const response = await axios.get(`${baseUrl}/hira`);
    return response.data;
  } catch (error) {
    console.error('erreur get all Hira:', error);
    return [];
  }
}

// get Hira by Id
export const getHiraById = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}/hira/${id}`);
    return response.data;
  } catch (error) {
    console.error(`erreur get Hira by Id ${id}:`, error);
    return null;
  }
}

// add Hira
export const addHira = async (Hira) => {
  try {
    const response = await axios.post(`${baseUrl}/hira`, Hira);
    return response;
  } catch (error) {
    console.error( "erreur lors de l'ajout du Hira", error);
    return [];
  }
}

// update Hira by Id
export const updateHiraById = async (id, Hira) => {
  try {
    const response = await axios.patch(`${baseUrl}/hira/${id}`, Hira, {
      headers:{
        'Cache-Control':'no-cache'
      }
    });
    return response;
  } catch (error) {
    console.error(`erreur lors de la modification du Hira by id ${id}:`, error);
    return null;
  }
}

// delete Hira by Id
export const deleteHiraById = async (id) => {
  try {
    const response = await axios.delete(`${baseUrl}/hira/${id}`);
    return response;
  } catch (error) {
    console.error(`erreur lors de la supression du Hira ${id}:`, error);
    return null;
  }
}
